import { List, Record } from "immutable";
import { Field } from "./registration-fields";

const defaults = {
    active: undefined,
    apiEndpoint: undefined,
    description: undefined,
    eulaDisplay: undefined,
    eulaUrl: undefined,
    id: undefined,
    editable: undefined,
    name: undefined,
    isLTL: undefined,
    registrationFields: undefined,
};

export class ShippingCarrier extends Record(defaults) {
    declare active: boolean;
    declare apiEndpoint: string;
    declare description: string;
    declare eulaDisplay: string;
    declare eulaUrl: string;
    declare id: string;
    declare editable: boolean;
    declare isLTL: boolean;
    declare name: string;
    declare registrationFields: List<any>;

    constructor(args) {
        super({
            ...args,
            apiEndpoint: args.api_endpoint,
            eulaDisplay: args.eula_display,
            eulaUrl: args.eula_url,
            editable: args.is_editable,
            isLTL: args.is_ltl,
            registrationFields: List(args.registration_fields && args.registration_fields.map((val) => new Field(val))),
        });
    }
}
